<HiddenFromSSR>
  <FreeTextLayout>
    <div class="not-logged-in-home">
      <div class="banner">
        <SvgIcon className="not-logged-in-home-svg" href="#logo" />
        <h1>{appName}</h1>
      </div>
      <div>
        {@html "<p> Enafore is a fediverse client with better support for Akkoma, glitch-soc, and Iceshrimp instances. </p>"}
        {#if singleInstance}
          <p style="text-align: right;">
            <button class="button primary" on:click="logIn()">{"Log in"}</button>
          </p>
        {:else}
          {@html "<p> Get started by logging in to an instance: </p>"}
          <p style="text-align: right;">
            <a class="button primary" rel="prefetch" href="/settings/instances/add">{"Log in"}</a>
          </p>
        {/if}
      </div>
  </FreeTextLayout>
</HiddenFromSSR>
<style>
  .not-logged-in-home {
    margin: 10px;
  }

  .not-logged-in-home .banner {
    display: flex;
    align-items: center;
    margin: 0 0 30px;
  }

  :global(.not-logged-in-home-svg) {
    width: 70px;
    height: 70px;
    fill: var(--banner-fill);
    display: inline-block;
  }

  .not-logged-in-home h1 {
    color: var(--banner-fill);
    display: inline-block;
    font-size: 3em;
    margin: auto 15px;
  }

  @media (max-width: 767px) {
    .not-logged-in-home h1 {
      font-size: 2.7em;
    }
  }

  @media (max-width: 240px) {
    .not-logged-in-home h1 {
      font-size: 2.5em;
    }
  }
</style>
<script>
  import FreeTextLayout from './FreeTextLayout.html'
  import HiddenFromSSR from './HiddenFromSSR.html'
  import SvgIcon from './SvgIcon.html'
  import { logInToInstance } from '../_actions/addInstance.js'

  export default {
    components: {
      FreeTextLayout,
      HiddenFromSSR,
      SvgIcon
    },
    data: () => {
      return {
        appName: process.env.UPSTREAM ? 'Enafore' : ENAFORE_IS_BROWSER ? location.hostname : '',
        singleInstance: process.env.SINGLE_INSTANCE
      }
    },
    methods: {
      logIn () {
        this.store.set({ instanceNameInSearch: process.env.SINGLE_INSTANCE })
        logInToInstance()
      }
    }
  }
</script>
